import { message, Table } from 'antd';
import { FastLink } from 'components/FastLink';
import { FETCH_ERROR } from 'constants/alerts';
import { COLUMN_MEDIUM, PAGE_SIZE_OPTIONS, SCROLL_Y } from 'constants/table';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState } from 'react';
import { ClientsService } from 'services/ClientsService';
import { renderWithTooltip } from 'utils/table';

function SegmentClientsTable({ isActive, segmentId }) {
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const { page, totalRows, perPage, setTotalRows, setPagination } =
    usePagination();

  useEffect(() => {
    fetchClientOfSegment();
  }, [page, perPage, isActive, segmentId]);

  const fetchClientOfSegment = async () => {
    if (!isActive || !segmentId || !page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items, total } = await ClientsService.getClientsOfSegment(
        page,
        perPage,
        segmentId
      );

      setClients(items);
      setTotalRows(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Пользователь',
      dataIndex: 'full_name',
      key: 'full_name',
      render: (value) => renderWithTooltip(value),
    },
    {
      width: COLUMN_MEDIUM,
      title: 'Действия',
      dataIndex: 'id',
      key: 'actions',
      render: (clientId) => {
        return (
          <FastLink
            text="Перейти к клиентам"
            path={`/clients/all-clients?client_id=${clientId}`}
          />
        );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={clients}
      loading={loading}
      scroll={{ y: SCROLL_Y }}
      rowKey="id"
      pagination={{
        page,
        pageSize: perPage,
        total: totalRows,
        showSizeChanger: true,
        pageSizeOptions: PAGE_SIZE_OPTIONS,
      }}
      onChange={setPagination}
    />
  );
}

export { SegmentClientsTable };
